import React from "react"
import Heading from "../../common/heading/Heading"
import "./Hero.css"
import { useNavigate } from "react-router-dom"

const Hero = () => {
  const navigate = useNavigate()

  return (
    <>
      <section className="hero">
        <div className="container">
          <div className="row">
            <Heading
              subtitle="WELCOME TO WELSH EDUCATION GROUP"
              title="Best Online And Abroad Education Expertise"
            />
            <p>
              At WELSH EDUCATION GROUP, we believe in providing quality education with a
              result-oriented approach.
            </p>
        
          </div>
        </div>
      </section>
      <div className="margin"></div>
    </>
  )
}

export default Hero
